var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wap"},[_vm._v(" this is a page "+_vm._s(this.$store.state.count)+" "),_c('div',{staticClass:"page"},[_vm._v("dkfhdhf ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }